import OffersResource from "./OffersResource";
import Utils from "../../common/Utils";
import ErrorConstants from "../../common/ErrorConstants";
import $ from "../../global/util";

const OffersManager = function (
  OffersResource,
  Utils,
  ErrorConstants,
  EmployeeObject
) {
  function getHomePageOffers(successCallback, errorCallback) {
    OffersResource.getHomePageOffers().then(
      function (homePageOffersResponse) {
        successCallback(homePageOffersResponse);
      },
      function (error) {
        error = Utils.updateErrorObject(error);
        errorCallback(errorCallback);
      }
    );
  }
  function getItemPromotions(params, successCallback, errorCallback) {
    OffersResource.getItemPromotions(params).then(
      function (searchResponse) {
        successCallback(searchResponse.data);
      },
      function (error) {
        error = Utils.updateErrorObject(error);
        errorCallback(error);
      }
    );
  }
  return {
    getHomePageOffers: getHomePageOffers,
    getItemPromotions: getItemPromotions,
  };
};

export default OffersManager(OffersResource, Utils, ErrorConstants);
